<template>
	<section class="other_page_banner banner_nxt_sec_touch">
		<div class="container">
			<div class="row">
				<div class="col-sm-7 order-2 order-md-1">
					<div class="ban_lt">
						<h5>
							<span>{{
								$t(
									'new_ui.personal_online_shopping_page.section_banner.title.one',
								)
							}}</span>
							{{
								$t(
									'new_ui.personal_online_shopping_page.section_banner.title.two',
								)
							}}
						</h5>
						<h2>
							{{
								$t(
									'new_ui.personal_online_shopping_page.section_banner.title.three',
								)
							}}
						</h2>
						<h6>
							{{
								$t(
									'new_ui.personal_online_shopping_page.section_banner.subtitle.one',
								)
							}}
							<span>{{
								$t(
									'new_ui.personal_online_shopping_page.section_banner.subtitle.two',
								)
							}}</span>
							<span style="font-weight: 700; color: #121a22">
								{{
									$t(
										'new_ui.personal_online_shopping_page.section_banner.subtitle.three',
									)
								}}
							</span>
						</h6>

						<div
							class="ban_lt_btn d-flex justify-content-start align-items-center p-top"
						></div>
					</div>
				</div>
				<div class="col-sm-5 order-1 order-md-2">
					<div class="ban_rt">
						<img :src="img.image26" alt="Logo" />
					</div>
				</div>
			</div>
		</div>
	</section>
	<section class="question_sec">
		<div class="container">
			<div class="row">
				<div class="col-sm-4 question_desk">
					<div class="question_lt">
						<img :src="img.image22" alt="" />
					</div>
				</div>
				<div class="col-sm-4 question_mob">
					<div class="question_lt">
						<img :src="img.image1" alt="" />
					</div>
				</div>
				<div class="col-sm-8">
					<div class="question_rt">
						<div class="payment_world_right">
							<span>{{
								$t(
									'new_ui.personal_online_shopping_page.section_question.label',
								)
							}}</span>
							<div class="payment_world_txt">
								<h4>
									{{
										$t(
											'new_ui.personal_online_shopping_page.section_question.title.one',
										)
									}}
									<span>{{
										$t(
											'new_ui.personal_online_shopping_page.section_question.title.two',
										)
									}}</span>
									{{
										$t(
											'new_ui.personal_online_shopping_page.section_question.title.three',
										)
									}}
								</h4>
								<p>
									{{
										$t(
											'new_ui.personal_online_shopping_page.section_question.description',
										)
									}}
								</p>
								<div class="starting_to_btn pay_world">
									<a href="/auth/register">{{
										$t(
											'new_ui.personal_online_shopping_page.section_question.cta_button',
										)
									}}</a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
	<section class="we_offer_sec">
		<div class="container">
			<div class="row">
				<div class="col-sm-12">
					<div class="we_offer_inn">
						<span>{{
							$t('new_ui.personal_online_shopping_page.section_we_offer.label')
						}}</span>
						<h5>
							{{
								$t(
									'new_ui.personal_online_shopping_page.section_we_offer.title.one',
								)
							}}
							<span>{{
								$t(
									'new_ui.personal_online_shopping_page.section_we_offer.title.two',
								)
							}}</span>
							{{
								$t(
									'new_ui.personal_online_shopping_page.section_we_offer.title.three',
								)
							}}
						</h5>
						<p>
							{{
								$t(
									'new_ui.personal_online_shopping_page.section_we_offer.description',
								)
							}}
						</p>
						<div class="enjoy_shopping_sec enjoy_desk">
							<div class="enjoy_shopping_box_sec">
								<div class="enjoy_shopping_inn">
									<div class="enjoy_shopping_box">
										<img :src="img.image9" alt="" />
										<div class="offer_round">1</div>
									</div>
									<div class="enjoy_shopping_dwn">
										<h6>
											{{
												$t(
													'new_ui.personal_online_shopping_page.section_we_offer.enjoy_shopping.boxes.one.title',
												)
											}}
										</h6>
										<p>
											{{
												$t(
													'new_ui.personal_online_shopping_page.section_we_offer.enjoy_shopping.boxes.one.description',
												)
											}}
										</p>
									</div>
								</div>

								<div class="enjoy_shopping_inn shoping_mid">
									<div class="enjoy_shopping_box">
										<img :src="img.image10" alt="" />
										<div class="offer_round offer_round2">2</div>
									</div>
									<div class="enjoy_shopping_dwn">
										<h6>
											{{
												$t(
													'new_ui.personal_online_shopping_page.section_we_offer.enjoy_shopping.boxes.two.title',
												)
											}}
										</h6>
										<p>
											{{
												$t(
													'new_ui.personal_online_shopping_page.section_we_offer.enjoy_shopping.boxes.two.description',
												)
											}}
										</p>
									</div>
								</div>

								<div class="enjoy_shopping_inn">
									<div class="enjoy_shopping_box">
										<img :src="img.image11" alt="" />
										<div class="offer_round">3</div>
									</div>
									<div class="enjoy_shopping_dwn">
										<h6>
											{{
												$t(
													'new_ui.personal_online_shopping_page.section_we_offer.enjoy_shopping.boxes.three.title',
												)
											}}
										</h6>
										<p>
											{{
												$t(
													'new_ui.personal_online_shopping_page.section_we_offer.enjoy_shopping.boxes.three.description',
												)
											}}
										</p>
									</div>
								</div>
							</div>

							<div class="starting_to_btn">
								<a href="/auth/register">{{
									$t(
										'new_ui.personal_online_shopping_page.section_we_offer.enjoy_shopping.cta_button',
									)
								}}</a>
							</div>
						</div>

						<div class="enjoy_shopping_sec enjoy_mob">
							<h6>
								{{
									$t(
										'new_ui.personal_online_shopping_page.section_we_offer.enjoy_shopping.title',
									)
								}}
							</h6>
							<p>
								{{
									$t(
										'new_ui.personal_online_shopping_page.section_we_offer.enjoy_shopping.subtitle',
									)
								}}
							</p>

							<div class="enjoy_slider">
								<swiper
									:slides-per-view="1"
									:space-between="30"
									:loop="true"
									:pagination="{
										el: '.swiper-pagination-2',
										clickable: true,
									}"
									:autoplay="{ delay: 2000, disableOnInteraction: false }"
									:breakpoints="{
										0: { slidesPerView: 1 },
										600: { slidesPerView: 1.5 },
										768: { slidesPerView: 2 },
										1000: { slidesPerView: 3 },
										1200: { slidesPerView: 4.5 },
									}"
								>
									<swiper-slide>
										<div class="enjoy_shopping_inn">
											<div class="enjoy_shopping_box">
												<img :src="img.image9" alt="" />
												<div class="offer_round">1</div>
											</div>
											<div class="enjoy_shopping_dwn">
												<h6>
													{{
														$t(
															'new_ui.personal_online_shopping_page.section_we_offer.enjoy_shopping.boxes.one.title',
														)
													}}
												</h6>
												<p>
													{{
														$t(
															'new_ui.personal_online_shopping_page.section_we_offer.enjoy_shopping.boxes.one.description',
														)
													}}
												</p>
											</div>
										</div>
									</swiper-slide>
									<swiper-slide>
										<div class="enjoy_shopping_inn">
											<div class="enjoy_shopping_box">
												<img :src="img.image10" alt="" />
												<div class="offer_round offer_round2">2</div>
											</div>
											<div class="enjoy_shopping_dwn">
												<h6>
													{{
														$t(
															'new_ui.personal_online_shopping_page.section_we_offer.enjoy_shopping.boxes.two.title',
														)
													}}
												</h6>
												<p>
													{{
														$t(
															'new_ui.personal_online_shopping_page.section_we_offer.enjoy_shopping.boxes.two.description',
														)
													}}
												</p>
											</div>
										</div>
									</swiper-slide>
									<swiper-slide>
										<div class="enjoy_shopping_inn">
											<div class="enjoy_shopping_box">
												<img :src="img.image11" alt="" />
												<div class="offer_round">3</div>
											</div>
											<div class="enjoy_shopping_dwn">
												<h6>
													{{
														$t(
															'new_ui.personal_online_shopping_page.section_we_offer.enjoy_shopping.boxes.three.title',
														)
													}}
												</h6>
												<p>
													{{
														$t(
															'new_ui.personal_online_shopping_page.section_we_offer.enjoy_shopping.boxes.three.description',
														)
													}}
												</p>
											</div>
										</div>
									</swiper-slide>
								</swiper>
								<!-- Move pagination outside swiper -->
								<div class="swiper-pagination-2"></div>
							</div>

							<div class="starting_to_btn">
								<a href="/auth/register">
									{{
										$t(
											'new_ui.personal_online_shopping_page.section_we_offer.enjoy_shopping.cta_button',
										)
									}}</a
								>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>

	<section class="online_mid">
		<div class="container">
			<div class="row">
				<div class="col-sm-12 border_dash">
					<div class="row">
						<div class="col-sm-6">
							<div class="business_anywhere_lt">
								<span>{{
									$t(
										'new_ui.personal_online_shopping_page.section_online_mid.label',
									)
								}}</span>
								<div class="business_anywhere_txt">
									<h4>
										{{
											$t(
												'new_ui.personal_online_shopping_page.section_online_mid.title.one',
											)
										}}
										<span>{{
											$t(
												'new_ui.personal_online_shopping_page.section_online_mid.title.two',
											)
										}}</span>
										{{
											$t(
												'new_ui.personal_online_shopping_page.section_online_mid.title.three',
											)
										}}
									</h4>
									<p>
										{{
											$t(
												'new_ui.personal_online_shopping_page.section_online_mid.description',
											)
										}}
									</p>
									<div class="starting_to_btn">
										<a href="/auth/register">{{
											$t(
												'new_ui.personal_online_shopping_page.section_online_mid.cta_button',
											)
										}}</a>
									</div>
								</div>
							</div>
						</div>
						<div class="col-sm-6">
							<div class="business_anywhere_rt">
								<img :src="img.image27" alt="" />
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>

	<section class="growth_sec">
		<div class="container growth_desk">
			<div class="row">
				<div class="col-sm-4">
					<div class="growth_inn">
						<div class="growth_inn_lt">
							<img :src="img.image23" alt="" />
						</div>
						<div class="growth_inn_rt">
							<h3>
								{{
									$t(
										'new_ui.personal_online_shopping_page.section_growth.stats.total_customers.value',
									)
								}}
							</h3>
							<p>
								{{
									$t(
										'new_ui.personal_online_shopping_page.section_growth.stats.total_customers.label',
									)
								}}
							</p>
						</div>
					</div>
				</div>
				<div class="col-sm-4">
					<div class="growth_inn">
						<div class="growth_inn_lt">
							<img :src="img.image24" alt="" />
						</div>
						<div class="growth_inn_rt">
							<h3>
								{{
									$t(
										'new_ui.personal_online_shopping_page.section_growth.stats.customer_satisfaction.value',
									)
								}}
							</h3>
							<p>
								{{
									$t(
										'new_ui.personal_online_shopping_page.section_growth.stats.customer_satisfaction.label',
									)
								}}
							</p>
						</div>
					</div>
				</div>
				<div class="col-sm-4">
					<div class="growth_inn">
						<div class="growth_inn_lt">
							<img :src="img.image25" alt="" />
						</div>
						<div class="growth_inn_rt">
							<h3>
								{{
									$t(
										'new_ui.personal_online_shopping_page.section_growth.stats.money_managed.value',
									)
								}}
							</h3>
							<p>
								{{
									$t(
										'new_ui.personal_online_shopping_page.section_growth.stats.money_managed.label',
									)
								}}
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="growth_mob">
			<div class="testi_slider">
				<swiper
					:slides-per-view="1.3"
					:space-between="5"
					:loop="true"
					:loopAdditional-slides="6"
					:centered-slides="true"
					:pagination="{
						el: '.swiper-pagination-5',
						clickable: true,
					}"
					:autoplay="{ delay: 2000, disableOnInteraction: false }"
				>
					<swiper-slide>
						<div class="growth_inn">
							<div class="growth_inn_lt">
								<img :src="img.image23" alt="" />
							</div>
							<div class="growth_inn_rt">
								<h3>
									{{
										$t(
											'new_ui.personal_online_shopping_page.section_growth.stats.total_customers.value',
										)
									}}
								</h3>
								<p>
									{{
										$t(
											'new_ui.personal_online_shopping_page.section_growth.stats.total_customers.label',
										)
									}}
								</p>
							</div>
						</div>
					</swiper-slide>
					<swiper-slide>
						<div class="growth_inn">
							<div class="growth_inn_lt">
								<img :src="img.image24" alt="" />
							</div>
							<div class="growth_inn_rt">
								<h3>
									{{
										$t(
											'new_ui.personal_online_shopping_page.section_growth.stats.customer_satisfaction.value',
										)
									}}
								</h3>
								<p>
									{{
										$t(
											'new_ui.personal_online_shopping_page.section_growth.stats.customer_satisfaction.label',
										)
									}}
								</p>
							</div>
						</div>
					</swiper-slide>
					<swiper-slide>
						<div class="growth_inn">
							<div class="growth_inn_lt">
								<img :src="img.image25" alt="" />
							</div>
							<div class="growth_inn_rt">
								<h3>
									{{
										$t(
											'new_ui.personal_online_shopping_page.section_growth.stats.money_managed.value',
										)
									}}
								</h3>
								<p>
									{{
										$t(
											'new_ui.personal_online_shopping_page.section_growth.stats.money_managed.label',
										)
									}}
								</p>
							</div>
						</div>
					</swiper-slide>
				</swiper>
				<!-- Move pagination outside swiper -->
				<div class="swiper-pagination-5"></div>
			</div>
		</div>
	</section>
	<section class="newsletter_sec">
		<div class="container">
			<div class="row">
				<div class="col-sm-12 col-xxl-5 col-xl-5 col-lg-5 col-md-12">
					<div class="newsletter_lt">
						<span>{{
							$t(
								'new_ui.personal_online_shopping_page.section_newsletter.label',
							)
						}}</span>
						<div class="newsletter_txt">
							<h4>
								<span>{{
									$t(
										'new_ui.personal_online_shopping_page.section_newsletter.title.one',
									)
								}}</span>
								{{
									$t(
										'new_ui.personal_online_shopping_page.section_newsletter.title.two',
									)
								}}
							</h4>
						</div>
					</div>
				</div>
				<div class="col-sm-12 col-xxl-7 col-xl-7 col-lg-7 col-md-12">
					<div class="newsletter_rt">
						<p>
							{{
								$t(
									'new_ui.personal_online_shopping_page.section_newsletter.description.one',
								)
							}}
						</p>
						<form>
							<div class="news_mail">
								<div class="news_mail_lt">
									<input
										type="email"
										:placeholder="
											$t(
												'new_ui.personal_online_shopping_page.section_newsletter.form.placeholder',
											)
										"
									/>
								</div>
								<div class="news_mail_rt">
									<button type="submit" value="submit">
										{{
											$t(
												'new_ui.personal_online_shopping_page.section_newsletter.form.button',
											)
										}}
									</button>
								</div>
							</div>
						</form>
						<p class="mt-3">
							{{
								$t(
									'new_ui.personal_online_shopping_page.section_newsletter.description.two',
								)
							}}
						</p>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import onlineban from '@/assets/images/sub/online_ban.png';
import crypto from '@/assets/images/sub/Crypto Wallet.png';
import smarter from '@/assets/images/sub/Shop Smarter.png';
import paywith from '@/assets/images/sub/Pay With Us.png';
import curveup from '@/assets/images/sub/Curve Arrow.png';
import curvedwn from '@/assets/images/sub/Curve_dwn.png';
import ques1 from '@/assets/images/sub/onlineinfo.png';
import customer from '@/assets/images/sub/Total Customers.png';
import satisfaction from '@/assets/images/sub/satisfaction.png';
import money from '@/assets/images/sub/money.png';
import handmob from '@/assets/images/sub/handmob.png';
import shpmobdia from '@/assets/images/sub/shp_mob_diagram.png';
import SwiperCore, { Autoplay, Pagination } from 'swiper';
SwiperCore.use([Autoplay, Pagination]);
export default {
	data: () => {
		return {
			img: {
				image9: crypto,
				image10: smarter,
				image11: paywith,
				image12: curveup,
				image13: curvedwn,
				image22: ques1,
				image23: customer,
				image24: satisfaction,
				image25: money,
				image26: onlineban,
				image27: handmob,
				image1: shpmobdia,
			},
		};
	},
};
</script>
